export default "__VITE_ASSET__BLiwQMCV__"